<template xmlns="http://www.w3.org/1999/html">
	<div
		class="report-container mod-joylearning__offringlist}"
		ref="mainBox"
		:style="{ width: mainBoxWidth + 'px', backgroundImage: 'url(' + backgroundImgUrl + ')' }"
		id="warter_mark_show_talent"
	>
		<div class="firstPage" id="warter_mark_show_firstPage">
			<div class="content" id="warter_mark_show_content">
				<div class="report-content">
					<div class="report-header">BMW/MINI经销商性格测试报告</div>
					<div class="split-line"></div>
					<div class="report-info">
						<span>候选人姓名：{{ resultData.candidateName }}</span>
						<span>日期：{{ resultData.examTime }}</span>
						<span>申请职位：{{ resultData.jobTitle }}</span>
						<span>经销商：{{ resultData.dealerName }}</span>
					</div>
					<div class="main-content">
						<div class="left-content">
							<div id="leiDaTu" class="echart" style="width:100%;"></div>
							<div class="report-remark">
								<el-row>
									<el-col :offset="2" :span="1"><span></span></el-col>
									<el-col :span="20" class="report-desc">注明:</el-col>
								</el-row>
								<el-row>
									<el-col :offset="2" :span="1"><span class="report-dotted"></span></el-col>
									<el-col :span="20">性格测试报告反映候选人的真实性格特质，无优劣之分。它将帮助您了解候选人的行为和思维模式，从而预测候选人在任职时的适应能力、工作效率、工作稳定性、以及压力承受能力等。</el-col>
								</el-row>
								<!-- <el-row>
									<el-col :offset="4" :span="1"><span class="report-dotted"></span></el-col>
									<el-col :span="18">每项性格特质得分将体现为1-100之间的一个分数。在报告中会提供对应的低分（30分及以下）、中分（31-70分）以及高分（71分及以上）人群的特征。</el-col>
								</el-row> -->
								<el-row>
									<el-col :offset="2" :span="1"><span class="report-dotted"></span></el-col>
									<el-col :span="20">每项性格特质得分将体现为1-100之间的一个分数。在报告中会提供对应的低分（30分及以下）、中分（31-70分）以及高分（71分及以上）人群的特征:</el-col>
								</el-row>
								<el-row>
									<el-col :offset="3" :span="20">性格特质项分数低于或等于30%：高风险
												<img alt="" src="@/assets/img/report/icon1.png" style="margin-left:10px;" /></el-col>
								</el-row>
								<el-row>
									<el-col :offset="3" :span="20">性格特质项分数超过30%：低风险
												<img alt="" src="@/assets/img/report/icon3.png" style="margin-left:10px;" /></el-col>
								</el-row>
								<el-row>
									<el-col :offset="2" :span="1"><span class="report-dotted"></span></el-col>
									<el-col :span="20">研究表明，有效的管理者在各个维度上的得分普遍高于平均水平，只有独立性和紧张性维度相反。根据应聘者得分，当某维度得分处于低分段（独立性和紧张性维度处于高分段）时，本报告会提供风险项红灯提示。当超过3个风险项时，需结合岗位的具体要求，进行综合判断。</el-col>
								</el-row>
							</div>
						</div>
						<div class="right-content">
							<div class="table-list">
								<div class="table-header">
									<span style="width:15%;"></span>
									<span style="width:16%;">得分</span>
									<span style="width:15%;">风险提示</span>
									<span style="width:50%;">性格特征分数解释</span>
								</div>
								<div class="table-content">
									<div v-for="(item, index) in tableData" :key="index">
										<div class="table-list-title">
											<span class="table-list-name">{{ item.name }}</span>
											<span class="display-icon" @click="showTable(index)" v-if="!item.showContent"><em class="el-icon-arrow-down" style="color:#1e68d5;font-size:24px;"></em></span>
											<span class="hideTable-icon" @click="hideTable(index)" v-if="item.showContent"><em class="el-icon-arrow-up" style="color:#1e68d5;font-size:24px;"></em></span>
										</div>
										<table v-show ="item.showContent" aria-describedby="">
											<tr style="border-bottom: 1px solid #d6d6d6" v-for="(subItem, index) in item.personalityExamDetailList" :key="index">
												<td style="width:15%;text-align:center;font-weight:600;">{{ subItem.questionSubClass }}</td>
												<td style="width:16%;text-align:center;">{{ subItem.percent }}</td>
												<td style="width:15%;text-align:center;">
													<img alt="" src="@/assets/img/report/icon1.png" v-if="subItem.risk" />
													<img alt="" src="@/assets/img/report/icon3.png" v-if="!subItem.risk" />
												</td>
												<td style="width:50%;text-align:left;font-size: 12px;">{{ subItem.content }}</td>
											</tr>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div>
						<el-row style="margin:30px 0;">
							<el-col :offset="10" :span="3" style="margin-bottom:40px;">
								<el-button type="primary" size="medium" style="width: 200px;height: 45px;font-size: 18px;" @click="tabRemove">确&nbsp;&nbsp;认</el-button>
							</el-col>
						</el-row>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import warterMark from '../../talent/warterMarkAcdc';

export default {
	components: {},
	data() {
		return {
			backgroundImgUrl: require('@/assets/img/report/bg.png'),
			icon1ImgUrl: require('@/assets/img/report/icon1.png'),
			icon2ImgUrl: require('@/assets/img/report/icon3.png'),
			tableData: [],
			chartList: [], //雷达图数据
			percentList: [], //百分数
			mainBoxWidth: '',
			resultData: {},
		};
	},
	computed: {},
	created() {
		console.log('created')
	},
	mounted() {
		var that = this;
		that.tableData = [];
		that.chartList = [];
		document.getElementById('leiDaTu').style.height = document.getElementById('leiDaTu').clientWidth / 1.2 + 'px';
		this.init();
		this.setWarterMark();//添加水印
	},
	watch: {
		// 监听,当路由发生变化的时候执行
		$route: {
			handler: function(val, oldVal) {
				if(val.query.bizId) {
					this.init();
					this.tableData = [];
					this.chartList = [];
				}
			},
			// 深度观察监听
			deep: true
		}
	},
	methods: {
		//加载数据
		init() {
			var that = this;
			// 链接示例:http://localhost:8001/#/natureReport?bizId=ff80808172318b0e0173ad1656d15a2d&bizType=1316281770079326209
			var bizId = this.$route.query.bizId;
			var bizType = this.$route.query.bizType;
			this.$request
				.get('/online/exam/personalityExamReport?bizId=' + bizId + '&bizType=' + bizType)
				.then((res, total, code, data) => {
					if (code == 1) {
						that.resultData = res;
						that.resultData.examTime =  that.formatDate(that.resultData.examTime);
						that.tableData = res.personalityExamList;
						that.tableData[0].showContent = true;//默认展开第一个
						that.parseChartData(that.tableData);
						this.$nextTick(function() {
							this.drawPie('leiDaTu');
						});
					} else {
						this.$message.warning(data.msg);
					}
				})
				.catch(error => {
					this.$message.warning(error);
				});
		},
		parseChartData(list) {
			this.chartList.splice(0,this.chartList.length)
			this.percentList.splice(0,this.percentList.length)
			for (let i = 0; i < list.length; i++) {
				var subItemList = list[i].personalityExamDetailList;
				for (let j = 0; j < subItemList.length; j++) {
					var str = '';
					if (subItemList[j].risk) {
						str = '{c1|}\n{a1|' + subItemList[j].questionKind + '}\n{b|' + subItemList[j].questionSubClass + '}';
					} else {
						str = '{c2|}\n{a1|' + subItemList[j].questionKind + '}\n{b|' + subItemList[j].questionSubClass + '}';
					}
					this.chartList.push({
						// 'name':'{c1|}\n{a'+Math.floor(Math.random()*this.colors.length)+'|'+list[i].name+'}\n{b|'+subItemList[j].questionSubClass+'}',
						name: str,
						max: 100
					});
					this.percentList.push(subItemList[j].percent);
				}
			}
		},
		showTable(index, type) {
			var temp = JSON.parse(JSON.stringify(this.tableData));
			temp[index].showContent = true ;//! temp[index].showContent

			this.tableData = temp;
		},
		hideTable(index){
			this.tableData = JSON.parse(JSON.stringify(this.tableData));
			this.tableData[index].showContent = false;
		},
		drawPie() {
			let charts = this.$echarts.init(document.getElementById('leiDaTu'));
			var option = {
				title: {
					text: '风险项提示',
					top: 0,
					bottom: 500
				},
				backgroundColor: 'transparent',
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross'
					}
				},
				width: 'auto',
				height: 'auto',
				// legend: {//图片tooltip
				//   // data: ["预算分配（Allocated Budget）", "实际开销（Actual Spending）"],
				// },
				radar: {
					// shape: 'circle',
					radius: '65%', // 半径
					name: {
						textStyle: {
							rich: {
								a1: {
									color: '#959595',
									lineHeight: 20,
									fontSize: 14,
									align: 'center'
								},
								b: {
									color: '#000000',
									lineHeight: 22,
									fontSize: 18,
									align: 'center'
								},
								c1: {
									backgroundColor: {
										image: this.icon1ImgUrl
									},
									width: 14,
									height: 14,
									lineHeight: 20,
									align: 'center'
								},
								c2: {
									backgroundColor: {
										image: this.icon2ImgUrl
									},
									width: 14,
									height: 14,
									lineHeight: 20,
									align: 'center'
								}
							},
							color: '#fff',
							borderRadius: 3,
							lineHeight: 15
						}
					},
					indicator: JSON.parse(JSON.stringify(this.chartList))
					// indicator: [
					//   { name: "{c1|}\n{a1|情绪管理}\n{b|稳定性}", max: 100 },
					//   { name: "{c2|}{a1|情绪管理}\n{b|紧张性}", max: 100 },
					//   { name: "{a2|自我管理}\n{b|成就动机}", max: 100 },
					// ],
				},
				series: [
					{
						name: '得分百分数',
						type: 'radar',
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [
									{
										offset: 0,
										color: 'rgba(0,198,255,0.5)' // 0% 处的颜色
									},
									{
										offset: 1,
										color: 'rgba(29,104,212,0.8)' // 100% 处的颜色
									}
								],
								global: false // 缺省为 false
							}
						},
						symbol: 'circle',
						symbolSize: 10,
						color: '#1d68d4',
						lineStyle: {
							color: '#1d68d4'
						},
						data: [
							{
								value: this.percentList //[90, 0, 90, 100, 100, 100, 0, 40, 90, 56, 90],
							}
						]
					}
				]
			};
			charts.setOption(option, false);
			charts.resize({
				width: 'auto',
				height: 'auto'
			});
		},
		// 获取图片宽高比
		getImgWandH(imgUrl, callback) {
			let img = new Image();
			img.src = imgUrl;
			img.onload = function() {
				callback(img.width / img.height);
			};
		},
		// setmainBoxWidth() {
		// 	// this.mainBoxWidth = this.$refs.mainBox.clientWidth;
		// },
		// 页面添加水印
		setWarterMark() {
			this.$request
				.post('/talent/talentpool/queryWarterMarkInfo', {})
				.then((res, total, code, data) => {
					this.dataListLoading = false;
					// console.log('水印');
					warterMark.set(data.data);
				})
				.catch(() => {
					this.dataListLoading = false;
				});
		},
		// 删除当前页面
		tabRemove () {
			let tabName = this.$store.state.contentTabsActiveName
			if (tabName === 'home') {
				return false
			}
			this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
			if (this.$store.state.contentTabs.length <= 0) {
				this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
				return false
			}
			// 当前选中tab被删除
			if (tabName === this.$store.state.contentTabsActiveName) {
				this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
			}
		},
		formatDate(val){
			let dates = val.split(' ');
			return dates[0];
		}
	}
};
</script>
<style lang="scss">
// @import "../../components/setStep/steps.css";
.report-container {
	font-family: Microsoft YaHei, sans-serif;
	width: 100%;
	height: auto;
	// padding: 0 20px;
	margin: 0 auto;
	background-repeat: no-repeat;
	background-size: 100% auto;
	background-color: #fff;
	.report-content {
		width: 100%;
		height: auto;
		// min-height: 680px;
		padding: 0 20px;
		.report-header {
			font-size: 24px;
			font-weight: bold;
			text-align: center;
			line-height: 42px;
			height: 42px;
			margin: 0 auto 15px auto;
			padding-top: 20px;
		}
		.split-line {
			width: 145px;
			height: 3px;
			background: #1d68d4;
			margin: 30px auto 0;
		}
		.report-info {
			margin: 30px auto 15px auto;
			font-weight: 500;
			span {
				margin-right: 10px;
			}
		}
		.main-content{
			position: relative;
			width: 100%;
			height: auto;
			display: flex;
			.left-content{
				width: 40%;
				height: auto;
				.echart{
					width: 100%;
				}
				.report-remark {
					width: 100%;
					position: relative;
					letter-spacing: 1px;
					.report-desc{
						font-weight:bold;font-size:18px;
					}
					.report-dotted{
						border-radius: 50%;
						background: #1d68d4;
						width: 4px;
						height: 4px;
						display: inline-block;
					}
					div{
						margin-top: 2px;
						line-height: 20px;
					}
				}
			}
			.right-content{
				width: 55%;
				margin-left: 3%;
				overflow-y: auto;
				.table-list {
					.table-header {
						width: 100%;
						display: flex;
						justify-content: space-around;
						height: 56px;
						line-height: 56px;
						background: #2296f1;
						color: #fff;
						border-radius: 3px;
						text-align: center;
						span {
							display: inline-block;
						}
					}
					.table-content {
						.table-list-title {
							height: 57px;
							line-height: 57px;
							background: #ebecf0;
							padding: 0 20px;
							display: flex;
							justify-content: space-between;
							border-top: 1px solid #d6d6d6;
							.table-list-name {
								font-weight: bold;
								font-size: 18px;
							}
							.display-icon,
							.hideTable-icon {
								width: 40px;
								text-align: center;
								pointer-events: auto;
							}
						}
						table {
							border-collapse: collapse;
							// display: none;
							height: 300px;
							overflow: auto;
							&.active {
								display: block;
							}
						}
						table tr {
							border-bottom: 1px solid #d6d6d6;
						}
						table tr td {
							line-height: 25px;
						}
					}
				}
			}
		}


		.height-200 {
			height: 200px;
		}
		.height-230 {
			height: 230px;
		}
		.height-300 {
			height: 300px;
		}
	}
}
</style>
